import type { ReactNode } from 'react'

interface ResponsiveTableWrapperProps {
  children: ReactNode
}

/**
 * Wraps tables to make them horizontally scrollable on mobile devices
 */
export function ResponsiveTableWrapper({
  children,
}: ResponsiveTableWrapperProps) {
  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[640px]">{children}</div>
    </div>
  )
}
